import { createSlice } from '@reduxjs/toolkit'
import { getUserProfile, getUserPreferences } from 'api/accounts'
import { getShipments } from 'api/shipping'

const initialState = {
  userProfile: null,
  userPreferences: null,
  updatingEmail: false,
  shipments: {
    data: null,
    pagination: {
      offset: 0,
      limit: process.env.REACT_APP_PAGINATION_LIMIT,
      total: 0,
    },
  },
  loading: false,
  error: null,
}

export const recipientSlice = createSlice({
  name: 'recipient',
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
      state.userProfile = action.payload
    },
    setUserPreferences: (state, action) => {
      state.userPreferences = action.payload
    },
    setUpdatingEmail: (state, action) => {
      state.updatingEmail = action.payload
    },
    getUserShipmentsStart: (state) => {
      state.loading = true
      state.error = null
    },
    getUserShipmentsSuccess: (state, action) => {
      state.loading = false
      state.shipments.data = action.payload.shipments
      state.shipments.pagination = {
        offset: action.payload.offset,
        limit: action.payload.limit,
        total: action.payload.total,
      }
    },
    getUserShipmentsFailure: (state, action) => {
      state.loading = false
      state.error = action.payload
    },
  },
})

const {
  setUserProfile,
  setUserPreferences,
  setUpdatingEmail,
  getUserShipmentsStart,
  getUserShipmentsSuccess,
  getUserShipmentsFailure,
} = recipientSlice.actions

export const getUserProfileInfo = (prn) => async (dispatch) => {
  const userProfile = await getUserProfile(prn)
  dispatch(setUserProfile(userProfile))
}

export const getUserPreferencesInfo = (prn) => async (dispatch) => {
  const userPreferences = await getUserPreferences(prn)
  dispatch(setUserPreferences(userPreferences))
}

export const updateLoginEmail = (status) => (dispatch) => {
  dispatch(setUpdatingEmail(status))
}

export const getUserShipments =
  (offset = 0, status = 'All') =>
  async (dispatch) => {
    try {
      dispatch(getUserShipmentsStart())
      const response = await getShipments({
        limit: process.env.REACT_APP_PAGINATION_LIMIT,
        offset: offset || 0,
        status,
      })

      if (!response?.data) {
        throw new Error('Invalid response from getShipments')
      }

      dispatch(
        getUserShipmentsSuccess({
          shipments: response.data.shipments || [],
          offset: Number(offset) || 0,
          limit: Number(process.env.REACT_APP_PAGINATION_LIMIT),
          total: response.data.total || 0,
        })
      )
    } catch (error) {
      console.error('Error fetching shipments:', error)
      dispatch(getUserShipmentsFailure(error.message))
    }
  }

export default recipientSlice.reducer
